/** @jsxRuntime classic */
/** @jsx jsx */
import {
  jsx,
  NavLink as MenuLink,
  Link as A,
  ThemeUICSSObject,
} from "theme-ui";
import NextLink from "next/link";
import { ReactNode } from "react";
export function NavLink({
  path,
  label,
  children,
  ...rest
}: {
  path: string;
  label: string;
  children?: ReactNode;
}) {
  return (
    <NextLink href={path}>
      <MenuLink {...rest}>{children ? children : label}</MenuLink>
    </NextLink>
  );
}
export function Link({
  path,
  label,
  children,
  ...rest
}: {
  path: string;
  label?: string;
  children?: ReactNode;
  sx?: ThemeUICSSObject;
  target?: string;
}) {
  return (
    <A sx={{ color: "primary" }} {...rest} href={path}>
      {children ? children : label}
    </A>
  );
}
